import ColoredText from '@webstollen/react-native/lib/components/CustomText/ColoredText'
import { FontAwesomeIcon } from '@webstollen/react-native/lib/fontawesome'
import React, { useContext } from 'react'
import { View } from 'react-native'
import { SessionContext } from '../../../../../../context/SessionContext'
import Button from '../../../../../../components/Button'
import ComponentWrapper from '../../../../../../components/ComponentWrapper'
import useStyles from './styles'
import { useHistory } from '@webstollen/react-native/lib/react-router'
import useDocument from '../../../../../../hooks/useDocument'

import {
  currencyToSymbol,
  dashboardsForBundle,
  notificationsForBundle,
  shopsForBundle,
  userForBundle,
} from '../../../../../../utils/booking'
import colors from '../../../../../../constants/colors'
import { useTranslation } from '@webstollen/react-native/lib/hooks/useTranslation'
import { Bundle } from '@dash.bar/types'
import Business from '../../../../../../assets/imgs/subscription/Business'
import Free from '../../../../../../assets/imgs/subscription/Free'
import Pro from '../../../../../../assets/imgs/subscription/Pro'

const Subscription = () => {
  const { company } = useContext(SessionContext)
  const history = useHistory()
  const styles = useStyles()
  const { t } = useTranslation()
  const bundle = useDocument<Record<string, any>>('bundle', company?.bundle)

  return (
    <ComponentWrapper title={t('accountOverview.subscription.your_subscription')}>
      <View style={styles.wrapper}>
        <View
          style={[
            styles.titleWrapper,
            company?.bundle === Bundle.free
              ? styles.backgroundFree
              : company?.bundle === Bundle.pro
              ? styles.backgroundPro
              : styles.backgroundBusiness,
          ]}
        >
          <ColoredText style={styles.title}>{`dash.bar ${company?.bundle || Bundle.free}`}</ColoredText>
          <View>
            {company?.bundle === Bundle.pro ? <Pro /> : company?.bundle === Bundle.business ? <Business /> : <Free />}
          </View>
        </View>
        <View style={styles.contentWrapper}>
          <View style={styles.contentAreaWrapper}>
            <View style={styles.itemWrapper}>
              <FontAwesomeIcon icon={'check'} color={colors.success} />
              <ColoredText style={styles.itemText}>{userForBundle(company?.bundle)}</ColoredText>
            </View>
            <View style={styles.itemWrapper}>
              <FontAwesomeIcon icon={'check'} color={colors.success} />
              <ColoredText style={styles.itemText}>{shopsForBundle(company?.bundle)}</ColoredText>
            </View>
            <View style={styles.itemWrapper}>
              <FontAwesomeIcon icon={'check'} color={colors.success} />
              <ColoredText style={styles.itemText}>{dashboardsForBundle(company?.bundle)}</ColoredText>
            </View>
            <View style={styles.itemWrapper}>
              <FontAwesomeIcon icon={'check'} color={colors.success} />
              <ColoredText style={styles.itemText}>{notificationsForBundle(company?.bundle)}</ColoredText>
            </View>
          </View>
          <View style={styles.divider} />
          <View style={styles.contentAreaWrapper}>
            <View style={styles.amountWrapper}>
              <ColoredText style={styles.amountText}>{`${bundle?.price?.month?.value} ${currencyToSymbol(
                bundle?.price?.month?.currency
              )} ${t('subscription.interval.text_month')}`}</ColoredText>
              <ColoredText style={styles.amountText}>{`${bundle?.price?.year?.value} ${currencyToSymbol(
                bundle?.price?.year?.currency
              )} ${t('subscription.interval.text_year')}`}</ColoredText>
            </View>
            <View style={styles.buttonWrapper}>
              <Button
                textStyle={{ color: 'white' }}
                onPress={() => history.push('/settings/subscription')}
                style={styles.button}
              >
                <>{t('accountOverview.subscription.change_subscription')}</>
              </Button>
            </View>
          </View>
        </View>
      </View>
    </ComponentWrapper>
  )
}

export default Subscription
